import { NgModule } from '@angular/core';
import { BaseSharedModule } from '../../shared/base-shared.module';
import { InquiryDetailsSidebarComponent } from './_components/inquiry-details-sidebar/inquiry-details-sidebar.component';
import { AppsSharedModule } from '../../apps-shared/apps-shared.module';
import { BaseInquiryRequirementsModalComponent } from './_components/base-inquiry-requirements-modal/base-inquiry-requirements-modal.component';
import { BaseOffersSortingDropdownComponent } from './_components/base-offers-sorting-dropdown/base-offers-sorting-dropdown.component';
import { BaseInquiryCalendarComponent } from './_components/base-inquiry-calendar/base-inquiry-calendar.component';
import { BaseInquiriesCalendarMetaComponent } from './_components/base-inquiries-calendar-meta/base-inquiries-calendar-meta.component';
import { BaseInquiryCandidatesAndOffersComponent } from './_components/base-inquiry-candidates-and-offers/base-inquiry-candidates-and-offers.component';
import { BaseInquiryEmployeeAvatarAndNameComponent } from './_components/base-inquiry-emloyee-avatar-and-name/base-inquiry-employee-avatar-and-name.component';
import { BaseCalendarBubblesListComponent } from './_components/base-calendar-bubbles-list/base-calendar-bubbles-list.component';
import { BaseInquiryBubbleComponent } from './_components/base-inquiry-bubble/base-inquiry-bubble.component';
import { BaseInquiryCandidateBubbleComponent } from './_components/base-inquiry-candidate-bubble/base-inquiry-candidate-bubble.component';
import { BaseInquiryDetailsSidebarContentComponent } from './_components/base-inquiry-details-sidebar-content/base-inquiry-details-sidebar-content.component';
import { BaseInquiryScrollService } from './_services/base-inquiry-scroll.service';
import { BaseInquiryHorizontalScrollComponent } from './_components/base-inquiry-horizontal-scroll/base-inquiry-horizontal-scroll.component';
import { BaseDirectInquiryTooltipComponent } from './_components/base-direct-inquiry-tooltip/direct-inquiry-tooltip.component';
import { BaseInquiryOfferLegendItemComponent } from './_components/base-inquiry-offer-legend-item/base-inquiry-offer-legend-item.component';

@NgModule({
  imports: [BaseSharedModule, AppsSharedModule],
  declarations: [
    BaseInquiriesCalendarMetaComponent,
    BaseInquiryBubbleComponent,
    InquiryDetailsSidebarComponent,
    BaseInquiryRequirementsModalComponent,
    BaseOffersSortingDropdownComponent,
    BaseInquiryDetailsSidebarContentComponent,
    BaseInquiryCalendarComponent,
    BaseInquiryCandidatesAndOffersComponent,
    BaseInquiryEmployeeAvatarAndNameComponent,
    BaseCalendarBubblesListComponent,
    BaseInquiryCandidateBubbleComponent,
    BaseInquiryHorizontalScrollComponent,
    BaseDirectInquiryTooltipComponent,
    BaseInquiryOfferLegendItemComponent,
  ],
  exports: [
    BaseInquiriesCalendarMetaComponent,
    BaseInquiryBubbleComponent,
    InquiryDetailsSidebarComponent,
    BaseInquiryRequirementsModalComponent,
    BaseOffersSortingDropdownComponent,
    BaseInquiryDetailsSidebarContentComponent,
    BaseInquiryCalendarComponent,
    BaseInquiryCandidatesAndOffersComponent,
    BaseInquiryEmployeeAvatarAndNameComponent,
    BaseCalendarBubblesListComponent,
    BaseInquiryCandidateBubbleComponent,
    BaseInquiryHorizontalScrollComponent,
    BaseDirectInquiryTooltipComponent,
    BaseInquiryOfferLegendItemComponent,
  ],
  providers: [BaseInquiryScrollService],
})
export class BaseInquiryModule {}
